module.exports = __webpack_public_path__ + "img/dashed_box.94e58e8f.png";